"use client";

function useContactUs() {
  const contactParams = [
    {
      icon: "ri:mail-fill",
      title: "Chat with sales",
      description: "Speak to our friendly team",
      link: {
        href: "mailto:sales@usecotton.io",
        label: "sales@usecotton.io",
      },
    },
    {
      icon: "ri:message-3-fill",
      title: "Chat to support",
      description: "We’re here to help",
      link: {
        href: "mailto:support@usecotton.io",
        label: "support@usecotton.io",
      },
    },
    {
      icon: "ri:map-pin-fill",
      title: "Visit Us",
      description: "Visit our office HQ",
      link: {
        href: "https://maps.app.goo.gl/VnJ5uJfxeFGGwnRZ7",
        label: " View on Google Maps",
        target: "_blank",
      },
    },
    {
      icon: "ri:phone-fill",
      title: "Call Us",
      description: "Mon-Fri from 9am to 6pm",
      link: {
        href: "tel:+2349167664447",
        label: " +234 916 766 4447",
      },
    },
  ];

  return { contactParams };
}

export default useContactUs;
